import "./login.css";
import React, { useState, useEffect, useCallback } from "react";
import ThemeSwitch from "../../Components/themeSwitch/themeSwitch";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";
import CustomerLeftPanel from "../../Components/CustomerLeftPanel/customer-left-panel";
import { useNavigate, useLocation } from "react-router-dom";

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
    const { showToast } = useToast();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState(""); // State to store email
  const [rememberMe, setRememberMe] = useState(false); // State to store "remember me" checkbox state
  const [error, setError] = useState("");
  const [isLogin, setIsLogin] = useState(false); // State to store "remember me" checkbox state
  const [isAuthCode, setIsAuthCode] = useState(false);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const [authCode, setAuthCode] = useState(new Array(6).fill(""));
  const [isRecoveryCode, setIsRecoveryCode] = useState(false);

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format
    return emailRegex.test(email);
  };

  // Password validation
  const validatePassword = (password) => {
    return password.length >= 8; // Password must be at least 8 characters long
  };
  const postLoginAPI = async (email, password) => {
    const apiUrl = "https://your-api-url.com/login"; // Replace with your API URL
    const bodyData = {
      email: email,
      password: password,
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });

    return response.json(); // Return the response data
  };
  const handleSubmitMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();

      try {
      } catch (err) {
        showToast(err.message, "error"); // Success toast
        return;
      }
    }, 2000), // Debounce time
    [userId] // Dependencies
  );
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLogin(true);

    // if (!validateEmail(email)) {
    //   setError("Please enter a valid email address.");
    //   return;
    // }
    // if (!validatePassword(password)) {
    //   setError("Password must be at least 8 characters long.");
    //   return;
    // }
    try {
      const response = await postLoginAPI(email, password);
      if (response.success) {
        alert("Login successful");
      } else {
        setError(response.message);
      }
    } catch (err) {
      setError("An error occurred during login. Please try again later.");
    }
  };
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !authCode[index] && index > 0) {
      document.getElementById(`code-input-${index - 1}`).focus();
    }
  };

  const handleChangeAuthCode = (value, index) => {
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...authCode];
      newOtp[index] = value;
      setAuthCode(newOtp);
      if (value && index < 5) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("text").slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setAuthCode(pasteData.split(""));
    }
    event.preventDefault();
  };
  const handletryAuthCode = (e) => {
    e.preventDefault();
    setIsAuthCode(true);
  };
  const handletryRecoveryCode = (e) => {
    e.preventDefault();
    setIsAuthCode(false);
    setIsRecoveryCode(true);
  };
  return (
    <div className="flex flex-col lg:flex-row h-screen dark:bg-[#101010] bg-[#FFFFFF]">
      <CustomerLeftPanel />
      {/* Right side */}
      <div className="w-full lg:w-2/5 flex flex-col">
        <ThemeSwitch />
        {!isLogin && !isRecoveryCode && !isAuthCode && (
          <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
            <h2 className="text-2xl mb-[32px] dark:text-white font-medium  mb-6">
              Log in to Caprock
            </h2>
            <form className="w-full max-w-sm" onSubmit={handleSubmit}>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block dark:text-gray-300 font-normal text-[#464646] text-md mb-1"
                >
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  value={email}
                  required={true}
                  className="input-field dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="name@email.com"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mb-4 relative">
                <label
                  htmlFor="password"
                  className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                >
                  Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  required={true}
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                  className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Type password"
                />
                <button
                  type="button"
                  onClick={togglePassword}
                  className="absolute right-3 set-top"
                >
                  {" "}
                  {showPassword ? (
                    <img src="/eye.svg" alt="Logo" className="h-auto" />
                  ) : (
                    <img src="/eye-slash.svg" alt="Logo" className="h-auto" />
                  )}
                </button>
                <div className="flex items-center pt-4 justify-between mb-6">
                  <div className="flex items-center"></div>
                  <a
                    href="#"
                    onClick={() => navigate("/forgot-password")}

                    className=" text-sm font-medium text-[#878787] hover:underline"
                  >
                    Forgot Password?
                  </a>
                </div>
              </div>
              <button
                type="submit"
                className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white font-medium text-sm py-3 rounded-full flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
              >
                <img
                  src="/profile-circle.svg"
                  alt="Login Icon"
                  className="h-6 w-6"
                />
                Log in
              </button>
            </form>
            <div className="mt-6 w-full max-w-sm text-center">
              <img src="/line.svg" alt="Logo" className="h-auto" />

              <p className="text-labelColour dark:text-[#CCCCCC] font-medium pt-2">
                Don’t have an account?{" "}
                <button
                  type="submit"
                  className="w-full dark:bg-[#101010] dark:text-white dark:border-[#424242] mt-2 bg-white rounded-full border-2 border-black text-black font-medium text-sm py-3 rounded flex items-center justify-center gap-2 hover:bg-[#F1F5F9] dark:hover:bg-[#1E293B]  transition duration-300"
                >
                  <img
                    src="/user-circle-add.svg"
                    alt="Login Icon"
                    className="h-6 w-6 dark:hidden"
                  />
                  <img
                    src="/user-circle-add-dark.png"
                    alt="Login Icon"
                    className="hidden dark:inline-block h-6 w-6"
                  />
                  Sign up
                </button>
              </p>
            </div>
          </div>
        )}
        {isLogin && !isRecoveryCode && !isAuthCode && (
          <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
            <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
              Approve your Sign in
            </h2>

            <form className="w-full max-w-sm " onSubmit={handleSubmitMobile}>
              <p className="text-sm  dark:text-white ">
                Use the number you see below in your Caprock Mobile App to sign
                in
              </p>
              <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                <img src="/sms.svg" alt="Success Icon" className="h-6 w-6" />
                <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                  {email}
                </p>
              </div>
              <div className="mt-6 mb-4 w-full max-w-sm  text-center text-4xl font-semibold text-black dark:text-white">
                <span className="bg-[#F9F9F9] px-4 py-2 rounded">83</span>
              </div>

              {/* "Didn't get a code?" Section */}
              <button
                type="submit"
                className="w-full mt-6 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white font-medium text-sm py-3 rounded-full flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
              >
                Get a New Code
              </button>
              <div className="text-center w-full max-w-sm mt-4 space-y-3">
                <a
                  href="#"
                  onClick={(e) => handletryAuthCode(e)}
                  className="text-sm text-[#003478] font-semibold underline block"
                >
                  Try your Authentication Code Instead
                </a>

                <span className="text-black font-medium block">-or-</span>

                <a
                  href="#"
                  onClick={(e) => handletryRecoveryCode(e)}
                  className="text-sm text-[#9C9C9C] font-semibold underline block"
                >
                  Use your Recovery Code
                </a>
              </div>
            </form>
          </div>
        )}
        {isLogin && !isRecoveryCode && isAuthCode && (
          <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
            <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
              Log in to Caprock
            </h2>

            <form className="w-full max-w-sm " onSubmit={handleSubmitMobile}>
              <p className="text-sm  dark:text-white ">
                Enter the number displayed on the homepage of your Caprock
                mobile app in the authentication section.
              </p>
              <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                <img src="/sms.svg" alt="Success Icon" className="h-6 w-6" />
                <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                  {email}
                </p>
              </div>
              <div className="flex w-full flex-col items-center justify-between">
                <div
                  onPaste={handlePaste}
                  className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                >
                  {authCode.map((digit, index) => (
                    <input
                      key={index}
                      id={`code-input-${index}`}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) =>
                        handleChangeAuthCode(e.target.value, index)
                      }
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
            dark:bg-[#101010] ${
              digit ? "border-[#003478]" : "grey"
            } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
            input-main`}
                    />
                  ))}
                </div>
              </div>

              {/* "Didn't get a code?" Section */}
              <div className="flex items-center pt-4  mb-6 justify-between mb-6">
                <div className="flex items-center"></div>
                <a
                  onClick={(e) => handletryRecoveryCode(e)}
                  href="#"
                  className=" text-sm font-semibold text-decoration text-sm text-[#878787] hover:underline"
                >
                  Use your Recovery Code
                </a>
              </div>
              <button
                type="submit"
                className="w-full bg-black rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 transition duration-300"
              >
                Submit
              </button>
            </form>
          </div>
        )}
        {isLogin && !isAuthCode && isRecoveryCode && (
          <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
            <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
              Log in to Caprock
            </h2>

            <form className="w-full max-w-sm " onSubmit={handleSubmitMobile}>
              <p className="text-sm  dark:text-white ">
                Enter a recovery code to access your account. Recovery codes are
                used when your phone is unavailable, and each code can only be
                used once.
              </p>
              <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                <img src="/sms.svg" alt="Success Icon" className="h-6 w-6" />
                <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                  {email}
                </p>
              </div>
              <div className="flex w-full flex-col items-center justify-between">
                <div
                  onPaste={handlePaste}
                  className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                >
                  {authCode.map((digit, index) => (
                    <input
                      key={index}
                      id={`code-input-${index}`}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) =>
                        handleChangeAuthCode(e.target.value, index)
                      }
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
            dark:bg-[#101010] ${
              digit ? "border-[#003478]" : "grey"
            } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
            input-main`}
                    />
                  ))}
                </div>
              </div>
              <button
                type="submit"
                className="w-full mt-10  bg-black rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 transition duration-300"
              >
                Submit
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};
export default LoginPage;
